import { useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { enableUserAccount } from "../../../../api/UserAPI";
import { Button, Tooltip } from "@mantine/core";
import { IconUserCheck } from "@tabler/icons-react";

const ActivateAccount = ({ profile, onSuccess }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);
  const onClick = () => {
    setLoading(true);
    enableUserAccount(profile.id)
      .then((response) => {
        onSuccess();
      })
      .finally(() => setLoading(false));
  };
  return (
    <Tooltip label={lang.administration.center.activate_account}>
      <Button
        color="green.8"
        variant="light"
        onClick={onClick}
        loading={loading}
        disabled={!profile}
        px={10}
        w={"100%"}
      >
        <IconUserCheck size={20} />
      </Button>
    </Tooltip>
  );
};
export default ActivateAccount;
